import { render, staticRenderFns } from "./DigitSpanForwardTutorial.vue?vue&type=template&id=85b9eae8&scoped=true&"
import script from "./DigitSpanForwardTutorial.vue?vue&type=script&lang=js&"
export * from "./DigitSpanForwardTutorial.vue?vue&type=script&lang=js&"
import style0 from "./DigitSpanForwardTutorial.vue?vue&type=style&index=0&id=85b9eae8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85b9eae8",
  null
  
)

export default component.exports